import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_USER_SIGNUP } from 'api/utilityActionTypes';

import analytics from 'client/analytics';

import getUtilityActivationByUserIdAction from 'client/actions/UtilityActivation/getByUserId';

export async function onLogicSuccess({ state, utilityApiClient, user }) {
  const analyticsSessionId = state.get(['analytics', 'analyticsSessionId']);

  await Promise.all([
    getUtilityActivationByUserIdAction(
      { state, utilityApiClient },
      { utilityUserId: user.id, forceRefresh: true },
    ),
  ]);

  state.set('utilityUser', user);

  analytics.alias(`up-${user.id}`, analyticsSessionId);
  analytics.identify(user);

  return user;
}

export default async function userSignup({ state, utilityApiClient }, params) {
  typeCheck('params::NonEmptyObject', params);

  const analyticsSessionId = state.get(['analytics', 'analyticsSessionId']);
  const experimentActiveVariants = state.get(['analytics', 'experiments', 'utilityActiveVariants']);

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_USER_SIGNUP,
    state: state,
    payload: {
      user: {
        firstName: params.firstName,
        lastName: params.lastName,
        email: params.email,
        phone: params.phone,
        password: params.password,
        analyticsSessionId,
        experimentActiveVariants,
      },
      addressId: params.address.id,
      utilityPartnerId: params.utilityPartnerId,
      leaseStartDate: params.leaseStartDate,
    },
    onSuccess({ user }) {
      return onLogicSuccess({
        state,
        utilityApiClient,
        user,
      });
    },
  });
}
